import * as Yup from 'yup';

export const validations = (
    questionDependencyType: string,
    getStartRange: () => number,
    getEndRange: () => number,
    isTextTypeQuestion: boolean
) =>
    Yup.object({
        type: Yup.string().required('El tipo de pregunta es obligatorio'),
        subtype: isTextTypeQuestion
            ? Yup.string().required('El subtipo de pregunta es obligatorio')
            : Yup.string().strip(),
        questionDependency: Yup.string()
            .nullable()
            .when(['dependency'], {
                is: (dependency: any) => dependency,
                then: (schema) =>
                    schema.required('La pregunta a depender es obligatoria'),
            }),
        range1: Yup.number().when({
            is: () => Boolean(questionDependencyType === 'linear'),
            then: (schema) =>
                schema
                    .typeError('El rango debe ser un número')
                    .min(
                        getStartRange(),
                        `El número debe ser mayor o igual a ${getStartRange()}`
                    )
                    .max(
                        Yup.ref('range2'),
                        `El número debe ser menor o igual al final del rango`
                    ),
        }),
        range2: Yup.number().when({
            is: () => Boolean(questionDependencyType === 'linear'),
            then: (schema) =>
                schema
                    .typeError('El rango debe ser un número')
                    .min(
                        Yup.ref('range1'),
                        `El número debe ser mayor o igual al inicio del rango`
                    )
                    .max(
                        getEndRange(),
                        `El número debe ser menor o igual a ${getEndRange()}`
                    ),
        }),
    });
